import React from 'react';
import classes from './Love.module.css';
import Love from 'assets/images/love.svg';
import SendFeedback from 'components/UI/SendFeedback/SendFeedback';

const Growth = () => {
  return (
    <div className={classes.Container}>
      <h1 className={classes.ComingSoon}>Coming Soon</h1>
      <div className={classes.LoveContainer}>
        <h1>Love</h1>
        <p>Act on your intentions, create shareable collections, pass it on.</p>
        <img src={Love} alt="Love" />
      </div>
      <SendFeedback />
    </div>
  );
};

export default Growth;
